<template>
  <div class="feedback">
    <van-form @submit="onSubmit">
      <div class="content_box">
        <div class="title">
          <img
            src="@/assets/images/feedback/feedback_content.png"
            alt=""
          />反馈内容
        </div>
        <van-field
          v-model="data.feedbackContent"
          rows="3"
          autosize
          type="textarea"
          maxlength="200"
          placeholder="请输入内容"
          show-word-limit
          :rules="[{ required: true, message: '请输入内容' }]"
        />
      </div>
      <div class="content_box">
        <div class="title">
          <img src="@/assets/images/feedback/picture.png" alt="" />上传图片<span
            >（选填，最多3张）</span
          >
        </div>
        <van-uploader
          class="upload"
          v-model="fileList"
          multiple
          :max-count="3"
          accept="image/*"
          :after-read="afterRead"
        />
      </div>
      <div class="btn_box">
        <van-button type="primary" class="btn_sty" native-type="submit"
          >提交</van-button
        >
        <div
          style="position: absolute; width: 100%; height: 100%; top: 0px"
          v-if="isSubscribe && templateId.length"
        >
          <OpenSubscribe
            :templateId="templateId"
            @open-subscribe-success="openSubscribeSuccess"
            @open-subscribe-error="openSubscribeError"
          >
          </OpenSubscribe>
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import { ossUpload } from "@/api/api";
import { feedbackAdd } from "@/api/Feedback";
import OpenSubscribe from "@/components/OpenSubscribe.vue";
export default {
  name: "Feedback",
  data() {
    return {
      data: {},
      fileList: [],
      templateId: ["G54MlsqmbF1nSWuRWbXD77X9RXs9vLTDdgBKI1DK9Yk"],
      isSubscribe: true,
    };
  },
  created() {},
  mounted() {},
  components: { OpenSubscribe },
  methods: {
    async onSubmit() {
      let arr = [];
      this.fileList.map((v) => {
        if (v.status === "done" && v.message === "上传完成") {
          arr.push(v.url);
        }
      });
      let feedbackImage = arr.join(",");
      await feedbackAdd({ feedbackImage, ...this.data });
      this.$toast("感谢您的意见反馈");
      this.$router.replace("/myFeedback");
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      let imgFile = new FormData();
      imgFile.append("file", file.file);
      file.status = "uploading";
      file.message = "上传中...";
      ossUpload(imgFile)
        .then((res) => {
          file.url = res.data.url;
          file.status = "done";
          file.message = "上传完成";
        })
        .catch(() => {
          file.status = "failed";
          file.message = "上传失败";
        });
    },
    openSubscribeSuccess() {
      this.isSubscribe = false;
      this.onSubmit();
    },
    openSubscribeError() {
      this.isSubscribe = false;
      this.onSubmit();
    },
  },
};
</script>
<style lang="scss" scoped>
.feedback {
  background: #f5f6fa;
  min-height: calc(100vh - 76px);
  padding: 15px;
  .content_box {
    background: #ffffff;
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 15px;
    .title {
      display: flex;
      font-size: 15px;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #eee;
      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
      span {
        font-size: 12px;
        color: #999;
      }
    }
    .van-field {
      margin-top: 5px;
      border: 1px solid #eee;
    }
    ::v-deep .upload {
      margin-top: 10px;
      .van-uploader__wrapper--disabled {
        opacity: 1;
      }
    }
  }
  .btn_box {
    position: relative;
    width: 100%;
  }
  .btn_sty {
    height: 45px;
    font-weight: 500;
    font-size: 15px;
    color: #ffffff;
    font-family: "PingFangSC-Medium";
    text-align: center;
    line-height: 45px;
    width: 100%;
  }
}
</style>
